import { useAppSelector } from "../store/hooks";
import { selectIsPremium } from "../store/billingSlice";

/**
 * Returns whether the current user has an active Premium subscription.
 * Reads from Redux state set by AuthBootstrap — no redundant JWT parsing.
 */
export function useIsPremium(): boolean {
  return useAppSelector(selectIsPremium);
}
